module.exports = __webpack_public_path__ + "assets/1fcbcedc5fd6c03a3f3be01d5ee3d61e.png";